import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette:{
        primary:{
          main:"#F7F7F7",
           dark:"#8C0900"
        },
        secondary:{
          main:'#122537',
          light:'#00468C'
        }
      }
})